import { css } from 'lit'

export default css`
    :host {
        --zaptic-centered-message-color: var(--grey-700);
        --zaptic-centered-message-margin: 0;
    }

    zaptic-modal-v2::part(content) {
        padding: 0;
    }

    zaptic-modal-v2::part(footer) {
        margin-top: 20px;
        padding: 0;
    }

    zaptic-modal-v2::part(wrapper) {
        min-width: 90%;
        padding: 32px 26px;
    }

    @media (min-width: 768px) {
        zaptic-modal-v2::part(wrapper) {
            min-width: auto;
            width: 550px;
        }
    }

    .footer {
        text-align: center;
        width: 100%;
    }

    .footer--grid {
        display: grid;
        gap: 10px;
        grid-auto-columns: minmax(0, 1fr);
        grid-auto-flow: row;
    }
`
